export enum AuroraHeatPumpMode {
  HEATING = 'heating',
  COOLING = 'cooling',
  HOT_WATER = 'hot_water',
  FREEZE_STAT = 'freeze_stat',
  LEGIONELLA = 'legionella',
  HEATING_ECO = 'heating_eco',
  OFF = 'off'
}

export default AuroraHeatPumpMode
